import { IRangeFilter, IStringFilter } from 'app/shared/model/filter.model';
import { Moment } from 'moment';

export const enum SignAttachmentCategory {
  SU = 'SU', // 《佛山市房屋租赁合同》补充协议模板
  SU2 = 'SU2', // 《佛山市房屋租赁合同（住房）》补充协议模板
  SU3 = 'SU3', // 《佛山市房屋租赁合同（非住宅）》补充协议模板
  SG = 'SG', // 建鑫乐家管理规约模板
  SE = 'SE', // 房屋租赁安全管理协议书模板
  SH = 'SH' // 房屋认租书模板
}

export interface ISignAttachmentSetting {
  id?: number;
  name?: string;
  houseId?: number;
  category?: SignAttachmentCategory;
  template?: any;
  createdAt?: Moment;
  createdBy?: string;
  updatedBy?: string;
  updatedAt?: Moment;
}

export const defaultValue: Readonly<ISignAttachmentSetting> = {};

export interface ISearchForm {
  name?: IStringFilter;
  category?: IStringFilter;
  createdAt?: IRangeFilter;
}

export const defaultSearchForm: ISearchForm = {
  createdAt: {
    lessOrEqualThan: '',
    lessThan: '',
    greaterOrEqualThan: '',
    greaterThan: ''
  },
  name: {
    contains: ''
  },
  category: {
    equals: ''
  }
};
